module.exports = __webpack_public_path__ + "static/media/laptop-computer-programming-svgrepo-com.9b84b2d4.svg";